import NormalGameManager from "../../manager/NormalGameManager";
import O1HD from "../../../../engines/gameEngine";
import gameConfig from "../../../../engines/configs/gameConfig";
import LakeDriftBattleNode from "./LakeDriftBattleNode";
import AddBattleCount from "./AddBattleCount";
import {BUNDLE_SMALL_NAME, getOneBundleByInstant} from "../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;
/**
 * 西湖节点
 */
@ccclass
export default class LakeNode extends cc.Component {

    @property({type:cc.Node,displayName:"漂流瓶节点数组"})
    driftBattleNodeArray : cc.Node[] = [];
    @property({type:cc.Node,displayName:"UI Node"})
    uiNode : cc.Node = null;

    @property({type:sp.Skeleton,displayName:"青蛙sp"})
    waSp : sp.Skeleton = null;
    @property({type:sp.Skeleton,displayName:"网sp"})
    netSp : sp.Skeleton = null;
    @property({type:cc.Node,displayName:"捞一捞按钮"})
    netBtnNode : cc.Node = null;

    @property({type:cc.Prefab,displayName:"湖漂流瓶预制体"})
    lakeDriftBattlePrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"物品Node"})
    goodsNode : cc.Node = null;
    @property({type:cc.Node,displayName:"网子前"})
    netFrontNode : cc.Node = null;
    @property({type:sp.Skeleton,displayName:"水花骨骼"})
    waterSp : sp.Skeleton = null;
    @property(cc.Prefab)
    chatFramePrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"贝壳节点"})
    shellNode : cc.Node = null;
    @property({type:cc.Label,displayName:"漂流瓶次数"})
    lbBattleCount : cc.Label = null;
    @property({type:cc.Prefab,displayName:"添加漂流瓶次数"})
    addBattleCountPrefab : cc.Prefab = null;

    //漂流瓶数组下标
    private readonly initDriftIndexArray : number[] = [0,1,2,3,4];
    private waOpenStatus : boolean = false;//青蛙 打开状态
    private mGameLayer : NormalGameManager;


    onLoad () {
        this.mGameLayer = NormalGameManager._instance;
        O1HD.on("LakeNode.shellAppear" , this.shellAppear , this );
    }

    start () {
        if ( !NormalGameManager._instance.getGameData().todayBattleCount ) {
            NormalGameManager._instance.setGameData({ todayBattleCount : 0 } , false );
        }
        if ( !NormalGameManager._instance.getGameData().accumulationBattleCount ){
            NormalGameManager._instance.setGameData( { accumulationBattleCount : 0 } , false );
        }
        this.shellAppear();
        this.refreshBattleCount();
    }

    private waFlag :boolean = false;
    /**
     * 青蛙
     * @param e
     */
    onBtnWa( e ){
        if ( this.waOpenStatus == false && this.waFlag == false ) {
            this.waFlag = true;
            this.waOpenStatus = true;
            O1HD.getManagers().soundMgr.playSound("anNiu").then();
            this.waSp.setCompleteListener(()=>{
                this.waSp.setCompleteListener(()=>{});
                this.waSp.setAnimation( 0 , "Gold" , true );
            })
            this.waSp.setAnimation( 0 ,"Tu" ,false  );
        }
    }

    /**
     * 青蛙获取金币
     */
    onBtnWaGetCoins( e ){
        if ( this.waOpenStatus == true ) {
            this.waOpenStatus = false;
            O1HD.getManagers().soundMgr.playSound("anNiu").then();
            O1HD.getManagers().gameMgr.addGoodsEffect( 1 , e.target.convertToWorldSpaceAR( cc.v2()) , this.uiNode );
            //添加物品到背包
            this.mGameLayer.onPushGoods( 90001 ,1 );
            this.waSp.setCompleteListener(()=>{
                this.waOpenStatus = true;
                this.waSp.setCompleteListener(()=>{});
                this.waSp.setAnimation( 0 , "Gold" , true );
            })
            this.waSp.setAnimation( 0 ,"Tu" ,false  );
        }
    }

    /**
     * 捕捞
     */
    onBtnNet(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( NormalGameManager._instance.getGameData().todayBattleCount == gameConfig.DRIFT_BATTLE_COUNT ) {
            this.openAddBattlePrefab();
            return;
        }
        this.netBtnNode.active = false;
        this.netSp.node.y = -540;
        this.netSp.node.active = true;
        let that = this;
        NormalGameManager._instance.getGameData().todayBattleCount++;
        NormalGameManager._instance.getGameData().accumulationBattleCount++;
        NormalGameManager._instance.writeGameData();
        this.refreshBattleCount();
        //
        cc.tween( this.netSp.node )
            .to(1,{ y : 40 })
            .call( ()=>{
                O1HD.getManagers().soundMgr.playSound("swag").then();
                let driftBattleEntity = NormalGameManager._instance.driftBattleManager.getRandomDriftBattleEvent();
                this.netSp.setCompleteListener(()=>{
                    // 触发
                    that.scheduleOnce(()=>{
                        let eventPrefab = cc.instantiate( this.lakeDriftBattlePrefab );
                        this.uiNode.addChild( eventPrefab );
                        eventPrefab.getComponent( LakeDriftBattleNode ).bindData( driftBattleEntity ).then();
                        this.netBtnNode.active = true;
                        this.goodsNode.active = false;
                        this.netFrontNode.active = false;
                        this.netSp.node.active = false;
                    },2);
                });
                this.scheduleOnce(()=>{
                    this.waterSp.node.active = true;
                    this.waterSp.setAnimation( 0 , "animation" , false );
                })
                //加载 物品类型
                if ( driftBattleEntity && driftBattleEntity.goodsType ) {
                    switch ( driftBattleEntity.goodsType ) {
                        case 1:
                            //加载物品
                            let bundle = getOneBundleByInstant( BUNDLE_SMALL_NAME.lakeGameBundle );
                            bundle.load( `asset/goods/${driftBattleEntity.goodsImgPath}` , cc.SpriteFrame , ( error,assets : cc.SpriteFrame )=>{
                                if ( error ) {
                                    console.error( "漂流瓶捞物品加载失败",driftBattleEntity.goodsImgPath );
                                    return;
                                }
                                this.goodsNode.getComponent( cc.Sprite ).spriteFrame = assets;
                            });
                            break;
                    }
                }else{
                    let bundle = getOneBundleByInstant( BUNDLE_SMALL_NAME.lakeGameBundle );
                    let randomIndex = Math.floor( Math.random() * 3 ) + 1;
                    bundle.load( `asset/goods/battle${randomIndex}` , cc.SpriteFrame , ( error,assets : cc.SpriteFrame )=>{
                        if ( error ) {
                            console.error( "漂流瓶捞物品加载失败",driftBattleEntity.goodsImgPath );
                            return;
                        }
                        this.goodsNode.getComponent( cc.Sprite ).spriteFrame = assets;
                    });
                }

                this.scheduleOnce(()=>{
                    this.goodsNode.active = true;
                    this.netFrontNode.active = true;
                },0.8 );
                this.netSp.setAnimation( 0 , "animation" ,false );
            })
            .start();
    }

    /**
     * 打开添加 漂流瓶次数预制体
     */
    openAddBattlePrefab(){
        let addBattleCountNode = cc.instantiate( this.addBattleCountPrefab );
        this.uiNode.addChild( addBattleCountNode );
        addBattleCountNode.getComponent( AddBattleCount ).bindData( this );
    }

    /**
     * 添加捕捞次数，清空今日捕捞次数
     */
    addBattleCount(){
        NormalGameManager._instance.setGameData({todayBattleCount:0} , false );
        NormalGameManager._instance.setGameData({hasWatchBattleFlag: true } , false );
        this.refreshBattleCount();
    }

    /**
     * 刷新漂流瓶次数
     */
    refreshBattleCount(){
        let todayCount : number = NormalGameManager._instance.getGameData().todayBattleCount;
        this.lbBattleCount.string = `(${todayCount}/${gameConfig.DRIFT_BATTLE_COUNT})`;
    }

    /**
     * 退出
     */
    onBtnExit(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.destroy();
        this.node.removeFromParent();
    }

    /**
     * 收集贝壳
     */
    onBtnCollectShell( ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.shellNode.active = false;
        // 背包 + 1
        this.mGameLayer.onPushGoods( 10300 ,1 );
        O1HD.getManagers().gameMgr.addGoodsEffect( 1 , this.shellNode.convertToWorldSpaceAR(cc.v2()) , this.uiNode );
        this.mGameLayer.setGameData({shellCollectDay:this.mGameLayer.getCurrentDay()} , false );
    }

    /**
     * 贝壳出现
     */
    shellAppear( ){
        if ( this.node && ( !this.mGameLayer.getGameData().shellCollectDay
            || this.mGameLayer.getGameData().shellCollectDay != this.mGameLayer.getCurrentDay() )) {
            this.shellNode.active = true;
            this.refreshBattleCount();
        }
    }

    onDisable(){
        O1HD.emit("normalMode.onBackNormal","xh");
    }

}
